import React from 'react';
import { PaymentMethod } from '../../types/index';

/**
 * Componente reutilizável: Select de método de pagamento
 */
export default function SelectMetodoPagamento({ value, onChange, className = '', disabled = false }) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className={`${className || 'w-full p-4 bg-white border-2 border-slate-100 rounded-2xl font-black outline-none'} ${disabled ? 'cursor-not-allowed bg-slate-200 border-slate-300 text-slate-600' : ''}`}
    >
      <option value={PaymentMethod.CASH}>Dinheiro</option>
      <option value={PaymentMethod.CARD}>Multibanco</option>
      <option value={PaymentMethod.TRANSFER}>Transferência</option>
      <option value={PaymentMethod.CHEQUE}>Cheque</option>
      <option value={PaymentMethod.PENDING}>Pendente</option>
      <option value={PaymentMethod.VOUCHER}>Voucher</option>
      <option value={PaymentMethod.MBWAY}>MBWay</option>
    </select>
  );
}



